export default "__VITE_ASSET__D3YMBKAC__"